import React from "react";
import { StyledButton, StyledSwipeableDrawer, StyledTypography } from "../../../../../styled-mui";
import MobileMenuWrapper from "../MobileMenuWrapper";
import { Box } from "@mui/material";
import { ImageLayout } from "../../../../elements/image/ImageLayout";
import SmartLink from "../../../../elements/smart-link/smart-link";
import { useNavigate } from "react-router";
import AsyncCall from "../../../../../_foundation/gtm/async.service";
import storeUtil from "../../../../../utils/storeUtil";
import { CLICK } from "../../../../../_foundation/constants/gtm";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

interface Props {
  open: boolean;
  entireMenuCloseHandler: () => any;
  closeCurrentMenu: () => any;
  menuLinksData: Record<string, any>;
}

const MobileOutilsMenu: React.FC<Props> = ({ open, entireMenuCloseHandler, closeCurrentMenu, menuLinksData }) => {
  const navigate = useNavigate();
  const OutilsData = menuLinksData?.outils;
  const universData = OutilsData?.Univers || [];
  const NAV_LEVEL_1 = "Outils De Conception";

  const onOutilsBtnClick = () => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: NAV_LEVEL_1,
      nav_level_2: "",
      nav_level_3: "",
      nav_type: "cta",
      btn_label: "Voir tous nos configurateurs",
      click_destination: OutilsData?.url || "",
    });
    entireMenuCloseHandler();
    navigate(OutilsData?.url);
  };

  const onLinkClick = (item: Record<string, any>, universe: Record<string, any>) => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: NAV_LEVEL_1,
      nav_level_2: universe?.name || "",
      nav_level_3: item?.title || "",
      nav_type: "link",
      btn_label: item?.title || "",
      click_destination: item?.link?.url,
    });
    entireMenuCloseHandler();
  };

  return (
    <StyledSwipeableDrawer
      anchor="left"
      open={open}
      onClose={closeCurrentMenu}
      onOpen={() => null}
      className="header-menu-level2 mobile-outils-menu">
      <MobileMenuWrapper
        title="Outils de conception"
        isASubMenu
        entireMenuCloseHandler={entireMenuCloseHandler}
        closeCurrentMenu={closeCurrentMenu}>
        <Box p={3}>
          {universData?.map((item: Record<string, any>, index: number) => (
            <Box key={item?.name + index} className="configurateur-mobile-entry" mb={6}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                {item?.icon && (
                  <ImageLayout
                    src={storeUtil.getUrlPicture(`${item.icon}`, "")}
                    height={24}
                    width={24}
                    styles={{ margin: "unset" }}
                  />
                )}
                <StyledTypography
                  variant="body1"
                  component="p"
                  style={{ fontSize: "15px", fontWeight: "600", lineHeight: "20px" }}>
                  {item?.name}
                </StyledTypography>
              </Box>
              <Box className="configurateur-mobile-links">
                {item?.configurateurs?.map((config: Record<string, any>, index: number) => (
                  <SmartLink
                    key={config?.title + index}
                    isExternal={config?.link?.type === "external"}
                    to={config?.link?.url || ""}
                    onClick={() => onLinkClick(config, item)}
                    styles={{
                      display: "block",
                      padding: "12px 0px",
                      fontWeight: "500",
                      fontSize: "16px",
                      lineHeight: "100%",
                      color: "rgba(66, 66, 66, 1)",
                    }}>
                    {config?.title}
                  </SmartLink>
                ))}
              </Box>
            </Box>
          ))}

          <StyledButton
            variant="text"
            onClick={onOutilsBtnClick}
            sx={{
              display: "flex",
              alignItems: "center",
              columnGap: "8px",
              fontSize: "15px",
              fontWeight: "500",
              lineHeight: "15px",
              textTransform: "none",
              color: "rgba(93, 137, 162, 1)",
              marginBottom: "35px",
            }}>
            Voir tous nos configurateurs
            <ArrowForwardIcon sx={{ width: 20 }} />
          </StyledButton>
        </Box>
      </MobileMenuWrapper>
    </StyledSwipeableDrawer>
  );
};

export default MobileOutilsMenu;
